<template>
  <div
    v-bind:style="showModalRqs ? {display: 'block'} : {display: 'none'}"
    class="modal"
    id="infoModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel"
    aria-hidden="true"
    style="display: none;"
  >
    <div class="modal-dialog modal-info modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Nuevos requerimientos de porteo</h4>
          <button
            @click="close"
            class="close"
            type="button"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <b-form>
            <b-row class="form-group">
              <b-col sm="5">
                <label for>Cantidad</label>
                <input type="number" required v-model="quantity" class="form-control">
              </b-col>
            </b-row>
            <b-row v-if="specialOperation" class="form-group">
              <b-col sm="5">
                <label for>Tipo de Carga</label>
                <v-select v-model="chargeType" :options="specialChargeTypes" label="name"></v-select>
              </b-col>
            </b-row>
          </b-form>
        </div>
        <div class="modal-footer">
          <button @click="saveRqs()" type="button" class="btn btn-primary">Guardar</button>
          <button @click="close" type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/helpers/api";
import constants from "@/constants";
import moment from "moment";
export default {
  name: "ModalAppointment",
  props: ["specialChargeTypes", "showModalRqs", "specialOperation", "addRqs"],
  data() {
    return {
      quantity: 0,
      chargeType: {}
    };
  },
  mounted() {},
  methods: {
    hasErros() {},
    saveRqs() {
      const { quantity, chargeType, addRqs } = this;
      let data = {
        quantity: parseInt(quantity),
        chargeType
      };
      addRqs(data);
      this.quantity = 0;
      this.chargeType = {};
      this.close(null);
    },
    close(e, rq = null) {
      this.truckSelected = {};
      this.$emit("close", rq);
    }
  }
};
</script>